import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Award, Calendar, Newspaper, Users } from "lucide-react";
import GalleryCard from "../components/GalleryCard";


const galleryData= [
  {
    id: 1,
    title: "Foundation Course Launch for Class 8th-12th Students",
    date: "January 15, 2025",
    category: "news",
    images: [
      "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&q=80",
      "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&q=80",
      "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80",
    ],
  },
  {
    id: 2,
    title: "Annual Excellence Awards Ceremony 2024",
    date: "December 20, 2024",
    category: "achievements",
    images: [
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&q=80",
      "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=800&q=80",
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&q=80",
      "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800&q=80",
    ],
  },
  {
    id: 3,
    title: "Interactive Science Workshop for Students",
    date: "November 10, 2024",
    category: "events",
    images: [
      "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=800&q=80",
      "https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=800&q=80",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&q=80",
    ],
  },
  {
    id: 4,
    title: "Teachers Day Celebration with Students",
    date: "September 5, 2024",
    category: "functions",
    images: [
      "https://images.unsplash.com/photo-1522661067900-ab829854a57f?w=800&q=80",
      "https://images.unsplash.com/photo-1511629091441-ee46146481b6?w=800&q=80",
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&q=80",
    ],
  },
  {
    id: 5,
    title: "Top Rankers of Board Examinations 2024",
    date: "June 15, 2024",
    category: "achievements",
    images: [
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&q=80",
      "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=800&q=80",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&q=80",
    ],
  },
  {
    id: 6,
    title: "Parent-Teacher Meeting - Academic Progress Review",
    date: "October 28, 2024",
    category: "events",
    images: [
      "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
      "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=80",
      "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80",
    ],
  },
  {
    id: 7,
    title: "New State-of-the-Art Computer Lab Inauguration",
    date: "August 12, 2024",
    category: "news",
    images: [
      "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800&q=80",
      "https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=800&q=80",
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80",
    ],
  },
  {
    id: 8,
    title: "Annual Day Celebration - Talent Showcase",
    date: "March 22, 2024",
    category: "functions",
    images: [
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80",
      "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800&q=80",
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&q=80",
      "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=800&q=80",
    ],
  },
];

const Gallery = () => {
  const [activeTab, setActiveTab] = useState("all");

  const categories = [
    { value: "all", label: "All Updates", icon: Award },
    { value: "news", label: "News", icon: Newspaper },
    { value: "events", label: "Events", icon: Calendar },
    { value: "achievements", label: "Achievements", icon: Award },
    { value: "functions", label: "Functions", icon: Users },
  ];

  const filteredPosts =
    activeTab === "all"
      ? galleryData
      : galleryData.filter((post) => post.category === activeTab);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Campus Gallery | SSS Achievers Coaching Institute Ghazipur</title>
        <meta name="description" content="Explore SSS Achievers' campus gallery – classrooms, library, student activities and events at Ghazipur's best coaching institute for Class 8-12." />
        <link rel="canonical" href="https://www.sssachievers.com/gallery" />
        <meta property="og:title" content="Campus Gallery | SSS Achievers Ghazipur" />
        <meta property="og:url" content="https://www.sssachievers.com/gallery" />
      </Helmet>
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary via-primary-light to-primary-glow text-primary-foreground py-20 px-4">
        <div className="container mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-in">
            SSS Achievers Gallery
          </h1>
          <p className="text-xl md:text-2xl text-primary-foreground/90 max-w-3xl mx-auto animate-fade-in">
            Celebrating Excellence, Innovation, and Academic Success in Ghazipur
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background to-transparent"></div>
      </section>

      {/* Tabs */}
      <section className="container mx-auto px-4 py-16 -mt-8">
        <div className="flex flex-wrap justify-start gap-2 bg-muted/50 p-2 rounded-lg mb-12">
          {categories.map(({ value, label, icon: Icon }) => (
            <button
              key={value}
              onClick={() => setActiveTab(value)}
              className={`flex items-center gap-2 px-6 py-3 rounded-md transition-all duration-300 ${
                activeTab === value
                  ? "bg-primary text-primary-foreground shadow-md scale-105"
                  : "bg-muted hover:bg-muted/70 text-muted-foreground"
              }`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </button>
          ))}
        </div>

        {/* Gallery Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 animate-fade-in">
          {filteredPosts.map((post) => (
            <div key={post.id} className="animate-scale-in">
              <GalleryCard
                title={post.title}
                date={post.date}
                images={post.images}
              />
            </div>
          ))}
        </div>

        {filteredPosts.length === 0 && (
          <div className="text-center py-20">
            <p className="text-muted-foreground text-lg">
              No posts available in this category yet.
            </p>
          </div>
        )}
      </section>
    </div>
  );
};

export default Gallery;
